module.exports = __webpack_public_path__ + "static/media/glow-bg.106fed6e.png";